@if (!carregando) {
  <div class="dashboard-b2b" [@esvanecerDesvanecer]="'in'">
    <div class="dashboard-header">
      <div>
        <h1>Dashboard &gt; B2B Gestão</h1>
        <p>Acessos do portal, pedidos B2B e conversão por vendedor, estado e cidade.</p>
      </div>

      <div class="filters">
        <div class="date-field">
          <label>Data inicial</label>
          <input type="date" [(ngModel)]="dataInicio" [max]="dataMaxima" />
        </div>
        <div class="date-field">
          <label>Data final</label>
          <input [appPeriodoFinal]="dataInicio" type="date" [(ngModel)]="dataFim" />
          @if (erroPeriodo) { <small class="text-danger" role="alert">{{ erroPeriodo }}</small> }
        </div>
        <div class="search-field">
          <label>Vendedor</label>
          <input type="text" [(ngModel)]="vendedorFiltro" (input)="vendedorFiltroId = null" placeholder="Pesquisar vendedor" />
          @if (vendedoresFiltrados().length > 0 && vendedorFiltroId == null) {
            <div class="suggestions">
              @for (vendedor of vendedoresFiltrados(); track vendedor) {
                <button type="button" (click)="selecionarVendedor(vendedor)">{{ vendedor.fullname }}</button>
              }
            </div>
          }
        </div>
        <button type="button" class="filter-button" (click)="atualizar()">Atualizar</button>
        <button type="button" class="clear-button" (click)="limparFiltros()">Limpar</button>
      </div>
    </div>

    <section class="cards-grid">
      <div class="metric-card">
        <span>Acessos</span>
        <strong>{{ totalAcessos | number:'1.0-0' }}</strong>
      </div>
      <div class="metric-card">
        <span>Pedidos B2B</span>
        <strong>{{ totalPedidos | number:'1.0-0' }}</strong>
      </div>
      <div class="metric-card">
        <span>Conversão</span>
        <strong>{{ conversaoGeral | number:'1.1-1' }}%</strong>
      </div>
    </section>

    <section class="panel wide day-panel">
      <div class="panel-title">
        <h2>Acessos x pedidos por dia</h2>
        <span>{{ conversaoGeral | number:'1.1-1' }}% conversão</span>
      </div>

      <div class="day-list">
        <div class="day-row day-row-header">
          <b>Dia</b>
          <span></span>
          <div>
            <span>Acessos</span>
            <span>Pedidos</span>
            <span>Conversão</span>
          </div>
        </div>
        @for (dia of dias; track dia.dia) {
          <div class="day-row">
            <b>{{ dia.dia }}</b>
            <div class="day-stack">
              <div class="day-success" [style.width.%]="larguraPedidosDia(dia)"></div>
              <div class="day-danger" [style.width.%]="larguraSemPedidoDia(dia)"></div>
            </div>
            <div class="day-metrics">
              <span>{{ dia.acessos | number:'1.0-0' }}</span>
              <span>{{ dia.pedidos | number:'1.0-0' }}</span>
              <span>{{ dia.conversao | number:'1.1-1' }}%</span>
            </div>
          </div>
        }
      </div>
    </section>

    <section class="three-columns">
      <div class="panel">
        <div class="panel-title">
          <h2>Acessos x pedidos por vendedor</h2>
        </div>
        <div class="ranking-list">
          @for (item of vendedores; track item) {
            <div class="ranking-row">
              <div class="ranking-label">{{ item.descricao }}</div>
              <div class="ranking-values">
                <span>{{ item.acessos }} acessos</span>
                <span>{{ item.pedidos }} pedidos</span>
                <span>{{ item.conversao | number:'1.1-1' }}%</span>
              </div>
              <div class="dual-bars">
                <span class="access" [style.width.%]="largura(item.acessos, maxVendedores)"></span>
                <span class="order" [style.width.%]="largura(item.pedidos, maxVendedores)"></span>
              </div>
            </div>
          }
        </div>
      </div>

      <div class="panel">
        <div class="panel-title">
          <h2>Acessos x pedidos por estado</h2>
        </div>
        <div class="ranking-list">
          @for (item of estados; track item) {
            <div class="ranking-row">
              <div class="ranking-label">{{ item.descricao || 'Sem estado' }}</div>
              <div class="ranking-values">
                <span>{{ item.acessos }} acessos</span>
                <span>{{ item.pedidos }} pedidos</span>
                <span>{{ item.conversao | number:'1.1-1' }}%</span>
              </div>
              <div class="dual-bars">
                <span class="access" [style.width.%]="largura(item.acessos, maxEstados)"></span>
                <span class="order" [style.width.%]="largura(item.pedidos, maxEstados)"></span>
              </div>
            </div>
          }
        </div>
      </div>

      <div class="panel">
        <div class="panel-title">
          <h2>Acessos x pedidos por cidade</h2>
        </div>
        <div class="ranking-list">
          @for (item of cidades; track item) {
            <div class="ranking-row">
              <div class="ranking-label">{{ item.descricao || 'Sem cidade' }}</div>
              <div class="ranking-values">
                <span>{{ item.acessos }} acessos</span>
                <span>{{ item.pedidos }} pedidos</span>
                <span>{{ item.conversao | number:'1.1-1' }}%</span>
              </div>
              <div class="dual-bars">
                <span class="access" [style.width.%]="largura(item.acessos, maxCidades)"></span>
                <span class="order" [style.width.%]="largura(item.pedidos, maxCidades)"></span>
              </div>
            </div>
          }
        </div>
      </div>
    </section>

    <section class="panel accesses-panel">
      <div class="panel-title">
        <h2>Relatório de acessos</h2>
        <div class="panel-actions">
          <button type="button" class="export-button" (click)="exportarAcessosExcel()" [disabled]="acessos.length === 0">Exportar Excel</button>
          <span>{{ acessos.length | number:'1.0-0' }} acessos</span>
        </div>
      </div>
      <div class="table-scroll">
        <table>
          <thead>
            <tr>
              <th>Cod ERP</th>
              <th>Nome</th>
              <th>Cidade</th>
              <th>Estado</th>
              <th>Vendedor</th>
              <th>Data de acesso</th>
            </tr>
          </thead>
          <tbody>
            @for (acesso of acessos; track acesso) {
              <tr>
                <td>{{ acesso.codigoErp }}</td>
                <td>{{ acesso.nome }}</td>
                <td>{{ acesso.cidade }}</td>
                <td>{{ acesso.estado }}</td>
                <td>{{ acesso.vendedor }}</td>
                <td>{{ acesso.dataAcesso | date:'dd/MM/yyyy HH:mm:ss' }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </section>
  </div>
}

@if (carregando) {
  <div class="dashboard-b2b loading">Carregando...</div>
}
